module.exports = __webpack_public_path__ + "static/media/unread-icon.00bab2d4.svg";